export default "__VITE_ASSET__82f7603e__"